import React from "react";
import "./CompactChat.css";

/// コメントデータの型定義
interface CommentData {
  id: string;
  userId: string; // ユーザー固有ID（ブラウザ固有）
  username: string;
  text: string;
  timestamp: number;
  color?: string;
}

/// CompactChatのProps型定義
interface CompactChatProps {
  comments: CommentData[];
  onExpand: () => void;
  commentCount: number;
}

/// コメントタイムスタンプのフォーマット関数
const formatCommentTimestamp = (timestamp: number): string => {
  const now = new Date();
  const commentDate = new Date(timestamp);
  const diffMinutes = Math.floor((now.getTime() - commentDate.getTime()) / (1000 * 60));
  
  if (diffMinutes < 1) {
    return "たった今";
  } else if (diffMinutes < 60) {
    return `${diffMinutes}分前`;
  } else {
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) {
      return `${diffHours}時間前`;
    } else {
      return commentDate.toLocaleDateString("ja-JP", {
        month: "numeric",
        day: "numeric"
      });
    }
  }
};

const CompactChat: React.FC<CompactChatProps> = ({
  comments,
  onExpand,
  commentCount,
}) => {
  // 最新の2-3件のコメントを取得
  const recentComments = comments.slice(-3).reverse();
  
  return (
    <div className="compact-chat" onClick={onExpand}>
      {/* ヘッダー */}
      <div className="compact-chat__header">
        <div className="compact-chat__title">
          <span className="compact-chat__icon">💬</span>
          <span className="compact-chat__count">チャット ({commentCount})</span>
        </div>
        <div className="compact-chat__action">
          <span className="compact-chat__tap-hint">タップして開く</span>
        </div>
      </div>
      
      {/* コメントプレビュー */}
      <div className="compact-chat__preview">
        {recentComments.length === 0 ? (
          <div className="compact-chat__empty">
            <span className="compact-chat__empty-text">
              まだコメントがありません
            </span>
          </div>
        ) : (
          recentComments.map((comment) => (
            <div key={comment.id} className="compact-chat__message">
              <span className="compact-chat__username">
                {comment.username}:
              </span>
              <span className="compact-chat__text">
                {comment.text}
              </span>
              <span className="compact-chat__timestamp">
                {formatCommentTimestamp(comment.timestamp)}
              </span>
            </div>
          ))
        )}
        
        {/* グラデーション フェードアウト */}
        <div className="compact-chat__fade"></div>
      </div>
      
      {/* タップエリア拡張用の要素 */}
      <div className="compact-chat__tap-area">
        <span className="compact-chat__expand-text">
          {recentComments.length > 0 ? "すべてのコメントを見る" : "コメントを書く"}
        </span>
      </div>
    </div>
  );
};

export default CompactChat; 